export {default as default} from './Make1099Faq'
